import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/ui/Button";
import Input from "components/ui/Input";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const dummyEmail = import.meta.env.VITE_APP_EMAIL;
    const dummyPassword = import.meta.env.VITE_APP_PASSWORD;

    if (!dummyEmail || !dummyPassword) {
      setError("Environment variables not loaded");
      return;
    }

    if (email === dummyEmail && password === dummyPassword) {
      localStorage.setItem("isAuthenticated", "true");
      navigate("/platform-overview-dashboard", { replace: true });
    } else {
      setError("Invalid email or password");
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-surface rounded-xl shadow-elevation-3 p-8 space-y-6">

        {/* App Branding */}
        <div className="text-center space-y-1">
          <h1 className="text-2xl font-bold text-text-primary">
            ProQoura
          </h1>
          <p className="text-sm text-text-secondary">
            Sign in to continue
          </p>
        </div>

        {/* Error */}
        {error && (
          <div className="bg-error/10 text-error text-sm px-4 py-2 rounded-md text-center">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <Input
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Button type="submit" className="w-full">
            Sign In
          </Button>
        </form>

        {/* Footer */}
        <p className="text-xs text-text-tertiary text-center">
          © {new Date().getFullYear()} ProQoura
        </p>
      </div>
    </div>
  );
};

export default Login;
